import React from "react";
import './student-engagement-score-leaderboard.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import PaginationComponent from "../../common/cw-pagination/cw-pagination-v2";
import StudentScoreDetails from "../student-score-details/student-score-details";


class StudentEngagementScoreLeaderBoard extends React.Component {


    state = {
        studentLeaderBoard: [],
        orginalStudentLeaderBoard: this.props.studentLeaderBoard,
        meta: {
            totalPages: Math.ceil(this.props.studentLeaderBoard.length / 10)
        }
    }

    page = 1
    limit = 10

    componentDidMount() {
        this.setPageData()
    }

    back() {
        this.props.back && this.props.back()
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.page = selectedPage
        this.setPageData()
    }


    showStudentDetail(item) {
        this.setState({ showStudentDetail: true, selectedStudent: item })
    }

    hideStudentDetail() {
        this.setState({ showStudentDetail: false, selectedStudent: "" })
    }


    setPageData() {

        console.log(this.startIndex, this.page, this.props.studentLeaderBoard)
        let orginalStudentLeaderBoard = this.props.studentLeaderBoard
        let start = this.limit * (this.page - 1)
        this.currentPage = this.page
        let studentLeaderBoard = orginalStudentLeaderBoard.slice(start, start + this.limit)

        this.setState({ studentLeaderBoard })
    }


    render() {

        if (this.state.showStudentDetail) {
            return <StudentScoreDetails back={() => this.hideStudentDetail()}
                selectedStudent={this.state.selectedStudent} />
        }

        return (
            <div className="student-engagement-score-leaderboard">
                <div ><img className="back-icon cursor-pointer" onClick={() => this.back()} src={getImageSource(ImageConstants.BACK_ICON)} /></div>
                <div className="d-flex align-items-center mt-3">
                    <img className="suitcase-icon mr-2" src={getImageSource(ImageConstants.BLACK_SUITCASE_ICON)} />
                    <span className="class-engagement-title">Student Leader Board </span>
                </div>
                <div className="table-wrapper mt-3">
                    <table className="table table-bordered" style={{ border: 'none' }}>
                        <thead className="class-header">
                            <tr className="first-header-bg">
                                <th className="border-top-left-radius" width='30%'>Student Name</th>
                                <th className="" width='10%'>Class</th>
                                <th width='10%'>Section</th>
                                <th width='10%'>Rank</th>
                                <th className="border-top-right-radius" width='10%'>Engagement Score</th>
                            </tr>
                        </thead>
                        <tbody id="rows" className="class-body">
                            {
                                this.state.studentLeaderBoard && this.state.studentLeaderBoard.length ? this.state.studentLeaderBoard.map(item => (
                                    <tr>
                                        <td className="teacher-name">
                                            <div className="d-flex flex-wrap teacher-name-text cursor-pointer" onClick={() => this.showStudentDetail(item)}>
                                                {item.name}
                                            </div>
                                        </td>
                                        <td className="assignment-count">
                                            {item.class}
                                        </td>
                                        <td className="assignment-count">
                                            {item.section}
                                        </td>
                                        <td className="assignment-count">
                                            {item.rank}
                                        </td>
                                        <td className="assignment-count">
                                            {item.engagementScore}
                                        </td>
                                    </tr>
                                ))
                                    :

                                    <tr>
                                        <td colSpan="5" align='center'> No Records Found</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <div className='card-footer'>
                    {
                        this.state.meta?.totalPages ?
                            <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                    }
                </div>
            </div>
        )
    }

}

export default StudentEngagementScoreLeaderBoard;